(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
// customElements.whenDefined('details-disclosure').then(() => {
//   class NavMenu extends DetailsDisclosure {
//     constructor() {
//       super();
//       this.init();
//     }

//     init() {
//       this.toggle = this.querySelector('summary');
//       this.content = this.querySelector('.main-menu__content');
      
//       if (this.toggle && this.content) {
//         this.toggle.addEventListener('click', this.onToggleClick.bind(this));
//       }

//       // ブレイクポイント変更時の処理を削除（常に同じ挙動にするため）
//     }

//     onToggleClick(event) {
//       event.preventDefault();
//       this.toggleMenu();
//     }

//     toggleMenu() {
//       const isOpen = this.getAttribute('open') === '';
//       if (isOpen) {
//         this.closeMenu();
//       } else {
//         this.openMenu();
//       }
//     }

//     openMenu() {
//       this.setAttribute('open', '');
//       this.content.style.display = 'block';
//     }

//     closeMenu() {
//       this.removeAttribute('open');
//       this.content.style.display = 'none';
//     }
//   }

//   customElements.define('main-menu', NavMenu);
// });

  } catch(e) { console.error(e); }
})();
})();
